import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import { VirtualOfficePlan } from '../../../components/common/VirtualOfficeSubscription/VirtualOfficePlan';
import { H3, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../Maeketplace.types';
import { ErrorToast } from '../../../components';
import { Node } from '../../../components/common/Node/Node';
import { colors } from '../../../styles/GlobalStyles';
import { useAppSelector } from '../../../app/hooks';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.colors.secondaryBlue};
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

interface InitialProps {
  step: any;
  setStep: Dispatch<SetStateAction<any>>;
  setModal: Dispatch<SetStateAction<boolean>>;
  selectedPackage: any;
  selectedLicence: any;
  setSelectedLicence: any;
  licenceDate: number;
  handlePayWithLicence: (step: PurchaseSteps) => void;
  handlePayWithoutLicence: (step: PurchaseSteps) => void;
}

export const Initial = ({
  step,
  setStep,
  selectedPackage,
  setModal,
  selectedLicence,
  setSelectedLicence,
  licenceDate,
  handlePayWithLicence,
  handlePayWithoutLicence
}: InitialProps) => {
  const handlePayTetherWithLicence = (event: any) => {
    event.currentTarget.disabled = true;
    handlePayWithLicence(PurchaseSteps.SUCCESS);
  };

  const handlePayWithoutTether = (event: any) => {
    event.currentTarget.disabled = true;
    setSelectedLicence(null);
    handlePayWithoutLicence(PurchaseSteps.SUCCESS);
  };

  const { licences } = useAppSelector((state) => state.settings);

  return (
    <div>
      <P2 mb='40'>
        {' '}
        United One Back Office is your entry to limitless possibilities! Secure
        your plan and start earning!
      </P2>
      <VirtualOfficePlan
        selected={selectedLicence}
        setSelected={setSelectedLicence}
        licences={licences}
      />
      <P2 mt='20' mb='40'>
        It is highly advised to select a multi-year access and{' '}
        <b>avoid the big risk</b> of losing the benefits in case you do not
        renew the Back Office in time.
      </P2>
      <H3 center mb='20'>
        Package Selected
      </H3>
      <Node
        id={selectedPackage?.id}
        key={selectedPackage?.id}
        condensed
        image={selectedPackage?.imageUrl}
        title={selectedPackage?.name}
        price={selectedPackage?.price}
        subscriptionPrice={selectedPackage?.subscriptionPrice}
        selectedLicence={selectedLicence}
        subtitle={selectedPackage?.subtitle}
        packagePrice={selectedPackage?.price}
        includesSubscription={selectedLicence?.access}
        info={<></>}
      />

      <Button mt={16} onClick={handlePayTetherWithLicence}>
        Confirm with selection
      </Button>

      <P2
        center
        mt='10'
        color={colors.primary900}
        onClick={handlePayWithoutTether}
        style={{ cursor: 'pointer' }}>
        Confirm without backoffice
      </P2>
    </div>
  );
};
